var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top-message"},[_c('van-icon',{attrs:{"name":"smile","color":"#FEB013","size":"100px"}}),_c('div',[_vm._v("已扫码登记，感谢~")])],1),_c('van-image',{staticClass:"bottom-img",attrs:{"src":require('../../assets/jpg_empty.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }